import { Component, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { EfxDataSource } from '@signal/component-library/efx-data-table';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';
import { EfxPagedAndSortingDataSource } from '../tabla-dinamica-buscador/tabla-dinamica-buscador.component';
import { ModalSize } from '@signal/component-library/efx-modal';
import { SharedService } from 'src/app/services/shared/shared.service';
@Component({
    selector: 'app-modal-history',
    templateUrl: './modal-history.component.html',
    styleUrls: ['./modal-history.component.scss'],
    standalone: false
})
export class ModalHistoryComponent implements OnChanges {
  @Input() showModal: boolean = false;
  dataSource: EfxDataSource;
  @Input() dataHistorialModal: any;
  @Output() historySelect: EventEmitter<string> = new EventEmitter<any>(null);
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<any>(true);
  modalSize = ModalSize;
  gridColumns: any;
  historySelected: string = "";
  constructor(
    private localStorage: LocalStorageService,
    private sharedService: SharedService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataHistorialModal && (changes.dataHistorialModal.currentValue !== changes.dataHistorialModal.previousValue)) {
      this.initDataTable();
    }
  }

  initDataTable() {
    this.dataSource = new EfxPagedAndSortingDataSource();
    this.localStorage.getColumnsFilter2.subscribe(columns => {

      const dataStructure = this.localStorage.getEstructuraDinamicaField;
      const fieldSelect = this.findSelectField(columns);

      if (fieldSelect) {
        fieldSelect.forEach(element => {
          let select = String(element).replace('_select', '');

          const structData = dataStructure.find(struct => struct.name === select);


          if (structData) {

            if (this.dataHistorialModal !== null && this.dataHistorialModal.length > 0) {
              this.dataHistorialModal.forEach(fila => {
                fila[structData.name + "_select"] =
                  this.sharedService.mostrarDataSelectGFD(
                    fila[structData.name],
                    structData.value,
                    structData.name
                  );
              })
            }
          }

        })
      }
      const fieldManual = columns.some(column => column.field === "producto");
      if (fieldManual) {
        if (columns.some(column => column.field === "marca_tarjeta")) {

          if (this.dataHistorialModal !== null && this.dataHistorialModal.length > 0) {
            this.dataHistorialModal.forEach(fila => {
              if (fila.hasOwnProperty("marca_tarjeta_desc")) {
                fila["marca_tarjeta"] = fila["marca_tarjeta_desc"]
              }
            })
          }

        }
      }

      this.gridColumns = columns;
      this.dataSource.clear();

      const length = this.dataHistorialModal ? this.dataHistorialModal.length : 0;

      this.dataSource.setData(this.dataHistorialModal);
      this.dataSource.setTotalRows(length);
      this.dataSource.setPageSize(length);
    })
  }

  selectedHistory() {
    this.historySelect.emit(this.historySelected);
  }

  didHide() {
    this.showModal = false;
    this.closeModal.emit(this.showModal);
  }

  seletedClickHistory(history) {
    this.historySelected = String(history);
  }

  findSelectField(columns) {
    const selectField = columns.filter(column => column.field.includes('_select'));

    if (selectField) {
      return selectField.map(item => item.field);
    } else {
      return null; // O cualquier otro valor para indicar que no se encontró
    }
  }

}
